import { TextModel } from '../primitive/text.model';
import { DateModel } from '../primitive/date.model';
import { ConfigConstants } from '../../config/config-constants';
import { CompositeModel } from './composite.model';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { DateModelOptions } from '../options/date-model-options';
import moment from 'moment';
import { isDefined } from '../../utilities/is-defined';

export class ComponentInformationModel extends CompositeModel {
    public manufacturer: TextModel;
    public modelNumber: TextModel;
    public manufacturedDate: DateModel;

    public constructor() {
        super('ComponentInformationModel');
        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const dateModelOption = new DateModelOptions({
            format: ConfigConstants.formatPatternMonthYear,
            displayOnlyMonthYear: true,
        });

        this.manufacturer = new TextModel('Manufacturer', 'Siemens AG');
        modelOptionsLoader.load(this.manufacturer, 'Fda2579Form', 'ComponentManufacturer');

        this.modelNumber = new TextModel('ModelNumber');
        modelOptionsLoader.load(this.modelNumber, 'Fda2579Form', 'ComponentModelNumber');

        this.manufacturedDate = new DateModel('Date', moment.invalid(), dateModelOption);
        modelOptionsLoader.load(this.manufacturedDate, 'Fda2579Form', 'ComponentManufacturedDate');
    }

    public toJSON(): JsonComponentInformationModel {
        return {
            manufacturer: this.manufacturer.value,
            modelNumber: this.modelNumber.value,
            manufacturedDate: this.manufacturedDate.value,
        };
    }
}

export class ComponentInformationFromJson extends ComponentInformationModel {
    public constructor(data: JsonComponentInformationModel) {
        super();
        this.manufacturer.value = data.manufacturer;
        this.modelNumber.value = data.modelNumber;
        this.manufacturedDate.value = isDefined(data.manufacturedDate)
            ? moment(data.manufacturedDate)
            : moment.invalid();
    }
}

export interface JsonComponentInformationModel {
    manufacturer: string;
    modelNumber: string;
    manufacturedDate: moment.Moment;
}
